import { generateCategoriesLinks } from '@app/utils/blog';
import type { LayoutLoad } from './$types';
import ButtonText from '$lib/elements/buttons/variants/ButtonText.svelte';

export const load: LayoutLoad = async ({ url, fetch }) => {
	const categoriesLinks = await generateCategoriesLinks(ButtonText, url.pathname, fetch);
	const routeData = await fetch(`/cms${url.pathname}`);

	if (!routeData.ok) {
		return {
			status: 302,
			redirect: '/'
		};
	}
	const json = await routeData.json();

	return {
		categoriesLinks: categoriesLinks,
		story: json.data.story
	};
};
